/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getArrayDecoder,
  getArrayEncoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";
import {
  getScopeInheritanceDecoder,
  getScopeInheritanceEncoder,
  type ScopeInheritance,
  type ScopeInheritanceArgs,
} from ".";

/** Policy scope */
export type PolicyScope = {
  /** Applicable subjects */
  subjects: Array<string>;
  /** Applicable resources */
  resources: Array<string>;
  /** Applicable actions */
  actions: Array<string>;
  /** Scope inheritance */
  inheritance: ScopeInheritance;
};

export type PolicyScopeArgs = {
  /** Applicable subjects */
  subjects: Array<string>;
  /** Applicable resources */
  resources: Array<string>;
  /** Applicable actions */
  actions: Array<string>;
  /** Scope inheritance */
  inheritance: ScopeInheritanceArgs;
};

export function getPolicyScopeEncoder(): Encoder<PolicyScopeArgs> {
  return getStructEncoder([
    [
      "subjects",
      getArrayEncoder(addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())),
    ],
    [
      "resources",
      getArrayEncoder(addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())),
    ],
    [
      "actions",
      getArrayEncoder(addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())),
    ],
    ["inheritance", getScopeInheritanceEncoder()],
  ]);
}

export function getPolicyScopeDecoder(): Decoder<PolicyScope> {
  return getStructDecoder([
    [
      "subjects",
      getArrayDecoder(addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())),
    ],
    [
      "resources",
      getArrayDecoder(addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())),
    ],
    [
      "actions",
      getArrayDecoder(addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())),
    ],
    ["inheritance", getScopeInheritanceDecoder()],
  ]);
}

export function getPolicyScopeCodec(): Codec<PolicyScopeArgs, PolicyScope> {
  return combineCodec(getPolicyScopeEncoder(), getPolicyScopeDecoder());
}
